import {Component} from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';

import NavigationService from '-/services/NavigationService';
import {StipsIcons} from '-/icons/icons';
import {setStipsWelcomeScreenShown} from '-/util/util';
import Form from '-/components/fields/Form';
import Button from '-/components/general/Button';

const styles = () => ({
    flexContainer: {
        display: 'flex'
    },
    flexItem: {
        marginBottom: '1.0625rem',
        flex: 2,
        '& li': {
            margin: '15px 0'
        }
    },
    imgContainer: {
        flex: 1,
        textAlign: 'center'
    },
    welcomeImg: {
        maxWidth: '100%',
        maxHeight: '100%'
    },
    desktop: {
        '@media all and (max-width: 768px)': {
            display: 'none'
        }
    },
    phone: {
        '@media all and (min-width: 768px)': {
            display: 'none'
        }
    }
});

class StipsWelcome extends Component {
    handleCloseButtonClick = () => {
        setStipsWelcomeScreenShown();
        NavigationService.next('stips');
    };

    renderContinueButton() {
        return (
            <section className="steps-buttons">
                <div className="row">
                    <div className="cell">
                        <Button tag="a" onClick={this.handleCloseButtonClick}>Continue</Button>
                    </div>
                </div>
            </section>
        );
    }

    render() {
        const {classes = {}, contactPhone} = this.props;
        const imgWrapper = classNames(classes.flexItem, classes.imgContainer);
        const desktopCls = classNames(classes.welcomeImg, classes.desktop);
        const phoneCls = classNames(classes.welcomeImg, classes.phone);

        return (
            <div className="stips-welcome-dialog">
                <Form standalone={true}>
                    <p className="info center">
                        <strong>BEFORE YOU BEGIN...</strong>
                    </p>
                    <p className="info">
                        <strong>We know getting all of these documents in at once can be challenging</strong>
                    </p>
                    <div className={classes.flexContainer}>
                        <div className={classes.flexItem}>
                            <p className="info">That&apos;s why you can...</p>
                            <ul>
                                <li>- upload as many as you can</li>
                                <li>- come back to the same link later and submit the rest</li>
                                <li>- check on the status of your documents from the same link</li>
                            </ul>
                        </div>
                        <div className={imgWrapper}>
                            <img className={desktopCls} src={StipsIcons.done} />
                            <img className={phoneCls} src={StipsIcons.phone} />
                        </div>
                    </div>
                    <a href={`tel:${contactPhone}`}>{contactPhone}</a>
                    <Button tag="a" onClick={this.handleCloseButtonClick}>Continue</Button>
                </Form>
            </div>
        );
    }
}
export default injectSheet(styles)(StipsWelcome);
